import allcourses1 from "../../assets/allcourses/allcourses1.jpg"
import allcourses2 from "../../assets/allcourses/allcourses2.jpg"
import allcourses5 from "../../assets/allcourses/allcourses5.jpg"
import allcourses6 from "../../assets/allcourses/allcourses6.jpg"




export const allcourses = [
    {
        banner: allcourses1,
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
        hasStarted: false
    },
    {
        banner: allcourses2,
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
        hasStarted: true
    },
    {
        banner: allcourses6,
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
        hasStarted: false
    },
    {
        banner: allcourses5,
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
        hasStarted: true
    },
    {
        banner: allcourses2,
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
        hasStarted: true
    },
    {
        banner: allcourses6,
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
        hasStarted: false
    },

]

export const inprogress = [
    {
        banner: allcourses2,
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX'
    },
    {
        banner: allcourses5,
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX'
    },
    {
        banner: allcourses2,
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX'
    }
]

export const completed = [
    {
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
        banner: allcourses2,
        remark: '100% Completed'
    }
]

export const wishlist = [
    {
        banner: allcourses2,
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
        duration: '6hr 24min | 2.6K views',
        price: 'N10,000'
    },
    {
        banner: allcourses5,
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
        duration: '6hr 24min | 2.6K views',
        price: 'N10,000'
    },
    {
        banner: allcourses2,
        title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
        duration: '6hr 24min | 2.6K views',
        price: 'N10,000'
    }
]

export const orderHistory = [{
    banner: allcourses1,
    title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
    isSuccessful: true,
    duration: '12 sections • 156 lectures • 12h 9m total length',
    transactionHistory: 'Purchased on 12/03/2022 10:30 AM'
},
{
    banner: allcourses2,
    title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
    isSuccessful: false,
    duration: '12 sections • 156 lectures • 12h 9m total length',
    transactionHistory: 'Transction Delined on 12/03/2022 10:30 AM'

}]

export const videoplayer = [
    {
        duration: '3mins',
        detail: 'Going where the action is: Understanding  user in context'
    },
    {
        duration: '3mins',
        detail: 'Going where the action is: Understanding  user in context'
    },
    {
        duration: '3mins',
        detail: 'Going where the action is: Understanding  user in context'
    },
    {
        duration: '3mins',
        detail: 'Going where the action is: Understanding  user in context'
    },
    {
        duration: '3mins',
        detail: 'Going where the action is: Understanding  user in context'
    },
    {
        duration: '3mins',
        detail: 'Going where the action is: Understanding  user in context'
    },
    {
        duration: '3mins',
        detail: 'Going where the action is: Understanding  user in context'
    },
    {
        duration: '3mins',
        detail: 'Going where the action is: Understanding  user in context'
    },
]